import { render, staticRenderFns } from "./InvoiceNewAttachmentDialog.vue?vue&type=template&id=673c07e4&scoped=true"
import script from "./InvoiceNewAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./InvoiceNewAttachmentDialog.vue?vue&type=script&lang=js"
import style0 from "./InvoiceNewAttachmentDialog.vue?vue&type=style&index=0&id=673c07e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673c07e4",
  null
  
)

export default component.exports